module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-login login-box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-fields-wrapper"
  }, [_c('div', {
    staticClass: "form-field-wrapper form-field-username"
  }, [_c('label', [_vm._v("Username\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.username),
      expression: "login.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.login.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-field-wrapper form-field-password"
  }, [_c('label', [_vm._v("Password\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-message-catch text-center"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-footer-area"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-field-wrapper form-field-submit"
  }, [_c('input', {
    staticClass: "submit button",
    attrs: {
      "type": "submit",
      "value": "Login"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49df1458!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Login.vue
// module id = 2465
// module chunks = 1